import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "container" }, " Application is starting up... ", -1)
const _hoisted_3 = [
  _hoisted_2
]

import { onBeforeMount, onMounted } from 'vue';
  import { useRouter } from 'vue-router';
  import { useSituation } from '@/use/useSituation';
  import { useToast } from 'vue-toastification';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'StartupView',
  setup(__props) {

  const router = useRouter();
  const toast = useToast();

  onBeforeMount(async () => {
    switch(await useSituation.getCurrent()) {
      case 'SITUATION_BROWSER_INSTALL':
        return _onSituationBrowserInstall();
      case 'SITUATION_BROWSER_CHOICE':
        return _onSituationBrowserChoice();
      default:
        return _onSituationHome();
    }
  });

  onMounted(() => {
    toast.info('I\'m a toast');
  });

  const _onSituationBrowserInstall = () => {
    router.push({name: 'browserInstall'});
  };

  const _onSituationBrowserChoice = () => {
    router.push({name: 'browserChoice'});
  };

  const _onSituationHome = () => {
    router.push({name: 'home'});
  };

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_3))
}
}

})